import { cn } from "@/shared/utils";
import { PropsWithChildren } from "react";

type EvaluatieSectieProps = {
    title: string;
    description: string;
    action?: React.ReactNode;
    headingLevel?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
};

export function EvaluatieSectie({ title, description, action, children, headingLevel = "h3" }: PropsWithChildren<EvaluatieSectieProps>) {
    const Heading = headingLevel;
    return (
        <div className="grid gap-6 py-8">
            <div className="flex items-start justify-between">
                <div>
                    <Heading className={cn("text-l font-medium", headingLevel === "h2" && "text-xl")}>{title}</Heading>
                    <p className="text-s text-content-subtle">{description}</p>
                </div>
                {action ? action : null}
            </div>
            {children}
        </div>
    );
}
